import speakerImage3 from "../Images/DrShoemaker.jpg";
import speakerImage4 from "../Images/DrGeary.jpg";
import React from "react";
import '../Styles/StaffPage2.scss';


function StaffPage2() {
   return(
      <div className='staffPage2Content'>
         <div className="staffPage2Container">
            <div className="staffPage2President">
               <div className="staffPage2PresidentTitle">
                  Dr. Troy Shoemaker, Camp President
               </div>
               <div>
                  < img className="staffPage2PresidentPic" src={speakerImage3} alt="SpeakerImage2"></img>
               </div>
               <div className="staffPage2PresidentDescription">
               Dr. Troy Shoemaker has served as the second president of Camp Connect <br></br>
               since 2012. God prepared Dr. Shoemaker to serve in the presidency <br></br>
               through successive academic roles in his lifetime as a camp administrator, <br></br>
               the administrator of one of America’s largest Christian camps, <br></br>
               and a camp academic vice president. Under his leadership, the camp has <br></br>
               experienced growth in enrollment, resources, and ministry outreach.<br></br>
               </div>
            </div>

            <div clasName = 'staffPage2hr'>
               <hr></hr>
            </div>

            <div className="staffPage2Director">
               <div className="staffPage2DirectorTitle">
                  Dr. Michael Geary, Camp Director
               </div>
               <div>
                  < img className="staffPage2DirectorPic" src={speakerImage4} alt="SpeakerImage2"></img>
               </div>
               <div className="staffPage2DirectorDescription">
               Dr. Michael Geary has served as director of Camp Connect since 2022. <br></br>
               Dr. Geary oversees the year-round management of camps and all other <br></br>
               camp activities. He has a burden for children, teen, and adults of  <br></br>
               all ages and seeks to see lives changed through the revival services. <br></br>
               
               </div>
            </div>
         </div>
      </div>
   )
}
export default StaffPage2;
